module.exports = __webpack_public_path__ + "img/match--type1_img6.033e1e33.png";